<template>
    <div class="row">
        <div class="col-lg-12 col-xl-8">
            <receipt-log-unit-detail-form
                :receipt-log-unit="receiptLogUnit"
                @requestDelivery="$emit('requestDelivery')"
            />
            <card v-if="receiptLogUnit.claimId" class="card">
                <h3 slot="header" class="card-title">Claim Detail</h3>
                <form class="view-only-form" autocomplete="off">
                    <div class="row">
                        <div class="col-md-3">
                            <base-input
                                id="claimId"
                                :value="receiptLogUnit.claimId"
                                name="claimId"
                                label="Claim ID"
                                disabled
                            />
                        </div>
                        <div class="col-md-3">
                            <base-input
                                id="claimStatus"
                                :value="receiptLogUnit.claimStatus"
                                name="claimStatus"
                                type="text"
                                label="Claim Status"
                                disabled
                            />
                        </div>
                        <div class="col-md-3">
                            <base-input
                                id="damageHours"
                                name="damageHours"
                                type="text"
                                label="Damage Hours"
                                :value="receiptLogUnit.damageHours || 0"
                                disabled
                            />
                        </div>
                        <div class="col-md-3">
                            <base-input
                                id="damageCost"
                                name="damageCost"
                                type="text"
                                label="Damage Cost"
                                :value="
                                    formatCurrency(receiptLogUnit.damageCost)
                                "
                                disabled
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <base-input
                                id="damageComment"
                                :value="receiptLogUnit.damageComment"
                                name="damageComment"
                                type="text"
                                label="Damage Comment"
                                disabled
                            />
                        </div>
                    </div>
                </form>
            </card>
        </div>
        <div class="col-lg-12 col-xl-4">
            <card class="card">
                <h3 slot="header" class="card-title">Documents</h3>
                <div
                    v-if="receiptLogUnit.files || receiptLogUnit.photos"
                    :class="$style.documentContainer"
                >
                    <div
                        v-for="file in receiptLogUnit.files"
                        :key="file.url"
                        :class="$style.document"
                    >
                        <base-button
                            size="sm"
                            type="info"
                            @click="$emit('download', file)"
                        >
                            <i class="fa fa-download mr-1" />{{ file.name }}
                        </base-button>
                    </div>
                    <ul :class="$style.images" class="col-12">
                        <li v-for="(photo, index) in photos" :key="photo.url">
                            <img
                                v-lazy="photo.src"
                                style="height: 100px"
                                @click="openGallery(index)"
                            />
                        </li>
                    </ul>
                    <LightBox
                        ref="lightbox"
                        show-caption
                        :images="photos"
                        :show-light-box="false"
                        :start-at="lightBoxStartAt"
                    />
                </div>
                <h4 v-else class="text-center">No documents found.</h4>
            </card>
        </div>
    </div>
</template>
<script>
import moment from "moment-timezone";
import LightBox from "vue-image-lightbox";
import ReceiptLogUnitDetailForm from "./ReceiptLogUnitDetailForm.vue";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";

export default {
    name: "ReceiptLogUnit",
    components: { ReceiptLogUnitDetailForm, LightBox },
    props: {
        receiptLogUnit: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            images: [],
            lightBoxStartAt: 0,
        };
    },
    computed: {
        damaged() {
            return this.receiptLogUnit?.damaged ? "yes" : "no";
        },
        receivedDate() {
            if (this.receiptLogUnit) {
                return moment(this.receiptLogUnit.date).format("MM/DD/YYYY");
            }
            return "--";
        },
        photos() {
            if (this.images) {
                return this.images.map((i) => ({
                    thumb: i.data,
                    src: i.data,
                    caption: i.notes,
                }));
            }
            return [];
        },
    },
    watch: {
        "receiptLogUnit.photos": async function update() {
            this.fetchPhotos();
        },
    },
    created() {
        this.fetchPhotos();
    },
    methods: {
        openGallery(index) {
            this.lightBoxStartAt = index;
            this.$refs.lightbox.showImage(index);
        },
        async fetchPhotos() {
            if (this.receiptLogUnit?.photos) {
                this.images = await Promise.all(
                    this.receiptLogUnit.photos.map(async (photo) => {
                        const image = await this.$store.dispatch(
                            "getImage",
                            photo.url,
                        );
                        return { data: image, notes: photo.notes };
                    }),
                );
            }
        },
        formatCurrency(value) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            return formatter.format(value);
        },
    },
};
</script>

<style module lang="scss">
.documentContainer {
    display: flex;
    flex-wrap: wrap;
}
.document {
    display: flex;
    padding: 8px;
}
.images {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding: 0px;
    li {
        padding: 4px;
    }
}
</style>
